import React from 'react'
import { X, Sparkles } from 'lucide-react'

interface DiscoveryProgressProps {
  isVisible: boolean
  discoveredCount: number
  onCancel: () => void
}

const DiscoveryProgress: React.FC<DiscoveryProgressProps> = ({
  isVisible,
  discoveredCount,
  onCancel,
}) => {
  if (!isVisible) return null

  return (
    <div className="absolute bottom-0 left-0 right-0 z-30 bg-white border-t border-gray-200 shadow-lg">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-acad-500 animate-pulse" />
            <span className="text-sm font-medium text-gray-700">
              Discovering related resources...
            </span>
          </div>
          <div className="flex items-center gap-3">
            {discoveredCount > 0 && (
              <span className="text-xs text-acad-600 font-semibold">
                Found {discoveredCount} new resource{discoveredCount !== 1 ? 's' : ''}
              </span>
            )}
            <button
              onClick={onCancel}
              className="flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700
                         px-2 py-1 rounded hover:bg-gray-100 transition-colors"
            >
              <X className="w-3 h-3" />
              Cancel
            </button>
          </div>
        </div>

        {/* Indeterminate progress bar */}
        <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-acad-500 rounded-full animate-progress-indeterminate" />
        </div>
      </div>
    </div>
  )
}

export default DiscoveryProgress
